import * as React from 'react';
const SvgReportEmpty = () => (
  <svg
    width="240"
    viewBox="0 0 242 203"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M195.157 55.5869C198.123 55.5869 200.525 53.1822 200.525 50.2162C200.525 47.25 198.123 44.8454 195.157 44.8454C192.193 44.8454 189.791 47.25 189.791 50.2162C189.791 53.1822 192.193 55.5869 195.157 55.5869Z"
      fill="#EAEEF9"
    />
    <path
      d="M120.577 159.467C163.483 159.467 198.265 124.665 198.265 81.7335C198.265 38.8024 163.483 4 120.577 4C77.6711 4 42.8887 38.8024 42.8887 81.7335C42.8887 124.665 77.6711 159.467 120.577 159.467Z"
      fill="#EAEEF9"
    />
    <g filter="url(#filter0_d_178_13623)">
      <path
        d="M142.33 126.254L74.8117 153.532C73.6816 153.955 72.4104 153.389 71.9866 152.401L33.1424 55.8695C32.7185 54.7388 33.2836 53.4668 34.2723 53.0427L101.791 25.7655C102.921 25.3414 104.192 25.9067 104.616 26.8961L143.46 123.286C144.025 124.558 143.46 125.83 142.33 126.254Z"
        fill="white"
      />
    </g>
    <path
      d="M112.526 69.1548L56.0251 91.9096C55.4601 92.1922 54.8952 91.9096 54.6125 91.3442C54.33 90.7789 54.6125 90.2135 55.1776 89.9309L111.537 67.1761C112.102 66.8935 112.667 67.1761 112.95 67.7415C113.232 68.3068 112.95 68.8722 112.526 69.1548Z"
      fill="#E6EDF5"
    />
    <path
      d="M114.645 74.667L58.2851 97.4218C57.7201 97.7044 57.1552 97.4218 56.8725 96.8564C56.5901 96.2911 56.8725 95.7257 57.4376 95.4431L113.797 72.6883C114.362 72.4057 114.927 72.6883 115.21 73.2537C115.492 73.8189 115.21 74.3843 114.645 74.667Z"
      fill="#E6EDF5"
    />
    <path
      d="M116.905 80.0374L60.5453 102.933C59.9803 103.216 59.4153 102.933 59.1329 102.368C58.8502 101.803 59.1329 101.238 59.6978 100.955L116.057 78.2001C116.622 77.9175 117.187 78.2001 117.47 78.7654C117.752 79.1894 117.47 79.8962 116.905 80.0374Z"
      fill="#E6EDF5"
    />
    <path
      d="M83.9929 99.8242L62.8051 108.446C62.2401 108.728 61.6752 108.446 61.3926 107.88C61.1101 107.315 61.3926 106.75 61.9577 106.467L83.1455 97.8455C83.7104 97.5629 84.2754 97.8455 84.5579 98.4109C84.6991 98.9761 84.5579 99.5415 83.9929 99.8242Z"
      fill="#E6EDF5"
    />
    <path
      d="M124.25 94.0296L126.086 98.6936C126.369 99.5417 126.086 100.531 125.239 100.814L69.444 123.427C68.5966 123.71 67.6077 123.427 67.3253 122.579L65.489 117.774C65.2065 116.926 65.489 115.936 66.3364 115.654L122.131 93.1816C122.979 92.899 123.826 93.323 124.25 94.0296Z"
      fill="#E3EAF2"
    />
    <path
      d="M128.629 104.771L130.465 109.435C130.748 110.283 130.465 111.272 129.617 111.555L73.8229 134.168C72.9754 134.451 71.9867 134.168 71.704 133.32L69.7265 128.515C69.4441 127.667 69.7265 126.678 70.5741 126.395L126.369 103.923C127.216 103.64 128.205 104.064 128.629 104.771Z"
      fill="#E3EAF2"
    />
    <path
      d="M132.866 115.512L134.703 120.176C134.985 121.024 134.703 122.014 133.855 122.296L78.0606 144.91C77.213 145.192 76.2243 144.91 75.9417 144.062L74.1054 139.398C73.823 138.55 74.1054 137.56 74.953 137.278L130.748 114.806C131.595 114.382 132.584 114.806 132.866 115.512Z"
      fill="#E3EAF2"
    />
    <path
      d="M72.1277 113.392L75.2353 121.166L69.444 123.427C68.5966 123.71 67.6077 123.427 67.3253 122.579L65.489 117.774C65.2065 116.926 65.489 115.936 66.3364 115.654L72.1277 113.392Z"
      fill="#989FB0"
    />
    <path
      d="M70.7155 126.395L87.6658 119.47L90.7732 127.243L73.8231 134.168C72.9756 134.451 71.9868 134.168 71.7043 133.32L69.7268 128.515C69.4443 127.808 69.868 126.819 70.7155 126.395Z"
      fill="#B4BACA"
    />
    <path
      d="M74.953 137.136L77.3543 136.147L80.4618 143.92L78.0606 144.91C77.213 145.192 76.2243 144.91 75.9417 144.062L74.1054 139.398C73.823 138.55 74.1054 137.56 74.953 137.136Z"
      fill="#B4BACA"
    />
    <path
      d="M75.8002 64.3495C75.659 56.5761 69.3026 50.2161 61.3926 50.2161H61.2513C53.3411 50.2161 46.9849 56.7174 46.9849 64.6321C47.1261 72.5467 53.6236 78.9068 61.5338 78.9068C65.9125 78.9068 69.7263 76.9281 72.4102 73.9601C74.6702 71.416 75.9415 68.1655 75.9415 64.4907C75.8002 64.4907 75.8002 64.4907 75.8002 64.3495ZM61.5338 74.3841C56.1662 74.3841 51.7873 70.0028 51.7873 64.6321C51.7873 59.2615 56.1662 54.8801 61.5338 54.8801H61.675C67.0426 54.8801 71.2801 59.1201 71.4214 64.3495C71.4214 64.4907 71.4214 64.4907 71.4214 64.6321C71.4214 67.0348 70.5739 69.2961 69.0201 70.992C67.0426 73.1121 64.5 74.3841 61.5338 74.3841Z"
      fill="#E6EDF5"
    />
    <path
      d="M75.8005 64.3495H71.1393C71.1393 59.1201 66.7604 54.8801 61.5342 54.8801H61.3928V50.2161H61.5342C69.303 50.2161 75.6593 56.5761 75.8005 64.3495Z"
      fill="#989FB0"
    />
    <g filter="url(#filter1_d_178_13623)">
      <path
        d="M169.874 148.161L101.65 122.72C100.52 122.296 99.9548 121.024 100.378 119.894L136.539 22.5148C136.963 21.3841 138.234 20.8187 139.364 21.2427L207.589 46.5415C208.719 46.9655 209.283 48.2375 208.859 49.3682L172.7 146.889C172.276 148.018 171.005 148.585 169.874 148.161Z"
        fill="white"
      />
    </g>
    <path
      opacity="0.4"
      d="M160.835 65.0562L155.326 62.9362L159.846 50.3575L165.355 52.3362L160.835 65.0562Z"
      fill="#E6EDF5"
    />
    <path
      d="M168.32 67.7414L162.671 65.6214L169.592 46.4001L175.101 48.52L168.32 67.7414Z"
      fill="#B4BACA"
    />
    <path
      d="M183.151 72.9708L177.643 70.9922L186.683 45.6934L192.333 47.6721L183.151 72.9708Z"
      fill="#B4BACA"
    />
    <path
      opacity="0.4"
      d="M190.215 75.5148L184.706 73.5362L187.107 66.6108L192.757 68.7309L190.215 75.5148Z"
      fill="#E6EDF5"
    />
    <path
      d="M186.259 85.8323L129.194 64.6321C128.629 64.4909 128.346 63.7841 128.488 63.2188C128.629 62.6534 129.335 62.3708 129.9 62.5122L186.966 83.7122C187.531 83.8536 187.814 84.5602 187.672 85.1256C187.39 85.6909 186.824 85.9735 186.259 85.8323Z"
      fill="#E6EDF5"
    />
    <path
      d="M184.141 91.3443L127.075 70.1441C126.51 70.0027 126.228 69.2961 126.369 68.7308C126.51 68.1654 127.216 67.8828 127.781 68.0242L184.847 89.2242C185.412 89.3656 185.695 90.0722 185.554 90.6375C185.412 91.2029 184.706 91.6269 184.141 91.3443Z"
      fill="#E6EDF5"
    />
    <path
      d="M182.163 96.8562L125.097 75.6562C124.532 75.5148 124.25 74.8082 124.391 74.2429C124.532 73.6775 125.239 73.3949 125.804 73.5361L182.87 94.7363C183.434 94.8775 183.717 95.5843 183.575 96.1496C183.293 96.8562 182.727 97.139 182.163 96.8562Z"
      fill="#E6EDF5"
    />
    <path
      d="M144.59 89.2241L123.12 81.3095C122.555 81.1681 122.272 80.4615 122.414 79.8961C122.555 79.3308 123.261 79.0482 123.826 79.1894L145.296 87.1042C145.862 87.2455 146.144 87.9522 146.003 88.5174C145.72 89.0828 145.155 89.3655 144.59 89.2241Z"
      fill="#DDDDDD"
    />
    <path
      d="M178.209 112.12L176.513 116.926C176.23 117.774 175.242 118.198 174.394 117.915L162.247 113.392L117.894 96.8563C117.046 96.5735 116.622 95.5843 116.905 94.7362L118.6 89.9308C118.882 89.083 119.871 88.6589 120.719 88.9416L164.789 105.336L177.078 109.859C178.066 110.424 178.49 111.272 178.209 112.12Z"
      fill="#E6EDF5"
    />
    <path
      d="M174.112 123.003L172.417 127.808C172.134 128.656 171.145 129.08 170.297 128.798L166.201 127.243L113.938 107.88C113.091 107.598 112.667 106.608 112.95 105.76L114.645 100.955C114.927 100.107 115.916 99.683 116.763 99.9656L169.168 119.47L173.124 121.024C173.97 121.307 174.394 122.155 174.112 123.003Z"
      fill="#E6EDF5"
    />
    <path
      d="M170.157 133.886L168.461 138.691C168.18 139.539 167.191 139.963 166.343 139.68L145.438 131.907L109.983 118.763C109.136 118.48 108.712 117.491 108.995 116.643L110.69 111.838C110.972 110.989 111.961 110.565 112.808 110.848L149.11 124.275L169.168 131.766C170.016 132.048 170.44 133.038 170.157 133.886Z"
      fill="#E6EDF5"
    />
    <path
      d="M112.808 110.848L149.11 124.275L145.438 131.766L109.983 118.622C109.136 118.339 108.712 117.35 108.995 116.502L110.69 111.696C110.972 110.99 111.961 110.566 112.808 110.848Z"
      fill="#B4B9C9"
    />
    <path
      d="M116.905 94.8777L118.6 90.0724C118.882 89.2244 119.871 88.8004 120.719 89.083L164.789 105.478L161.964 113.251L117.894 96.8564C117.046 96.5737 116.622 95.7257 116.905 94.8777Z"
      fill="#B4B9C9"
    />
    <path
      d="M169.168 119.47L166.201 127.243L113.938 107.88C113.091 107.598 112.667 106.608 112.95 105.76L114.645 100.955C114.927 100.107 115.916 99.683 116.763 99.9656L169.168 119.47Z"
      fill="#B4B9C9"
    />
    <path
      d="M131.312 93.0402L128.488 100.814L117.894 96.8563C117.046 96.5735 116.622 95.5843 116.905 94.7362L118.6 89.9308C118.882 89.083 119.871 88.6589 120.719 88.9416L131.312 93.0402Z"
      fill="#DDDDDD"
    />
    <path
      d="M116.763 99.9656L127.357 103.923L124.532 111.696L113.938 107.739C113.091 107.456 112.667 106.467 112.95 105.619L114.645 100.814C115.068 100.107 115.916 99.6828 116.763 99.9656Z"
      fill="#DDDDDD"
    />
    <path
      d="M112.808 110.848L123.402 114.806L120.577 122.579L109.983 118.622C109.136 118.339 108.712 117.35 108.995 116.502L110.69 111.696C110.972 110.99 111.961 110.566 112.808 110.848Z"
      fill="#DDDDDD"
    />
    <g filter="url(#filter2_d_178_13623)">
      <path
        d="M157.727 124.558H84.9817C83.8516 124.558 82.8628 123.568 82.8628 122.438V18.416C82.8628 17.2853 83.8516 16.2961 84.9817 16.2961H157.727C158.856 16.2961 159.846 17.2853 159.846 18.416V122.296C159.987 123.568 158.998 124.558 157.727 124.558Z"
        fill="white"
      />
    </g>
    <path
      d="M151.37 56.292H90.632C90.0671 56.292 89.502 55.8683 89.502 55.1621C89.502 54.597 89.9257 54.0321 90.632 54.0321H151.37C151.935 54.0321 152.501 54.4558 152.501 55.1621C152.501 55.7271 151.935 56.292 151.37 56.292Z"
      fill="#E6EDF5"
    />
    <path
      d="M151.37 62.0868H90.632C90.0671 62.0868 89.502 61.663 89.502 60.9568C89.502 60.3919 89.9257 59.8268 90.632 59.8268H151.37C151.935 59.8268 152.501 60.2505 152.501 60.9568C152.501 61.663 151.935 62.0868 151.37 62.0868Z"
      fill="#E6EDF5"
    />
    <path
      d="M151.37 68.0229H90.632C90.0671 68.0229 89.502 67.5992 89.502 66.8928C89.502 66.3279 89.9257 65.7629 90.632 65.7629H151.37C151.935 65.7629 152.501 66.1866 152.501 66.8928C152.501 67.5992 151.935 68.0229 151.37 68.0229Z"
      fill="#E6EDF5"
    />
    <path
      d="M151.229 90.2122H130.747C130.182 90.2122 129.617 89.7885 129.617 89.0823C129.617 88.5172 130.041 87.9522 130.747 87.9522H151.229C151.794 87.9522 152.359 88.3759 152.359 89.0823C152.218 89.6472 151.794 90.2122 151.229 90.2122Z"
      fill="#E6EDF5"
    />
    <path
      d="M118.176 96.2911C118.035 88.5177 111.678 82.1577 103.768 82.1577H103.627C95.7166 82.1577 89.3604 88.659 89.3604 96.5737C89.3604 104.488 95.858 110.99 103.768 110.99C108.147 110.99 111.961 109.011 114.644 106.043C116.904 103.499 118.176 100.248 118.176 96.5737C118.176 96.4323 118.176 96.2911 118.176 96.2911ZM103.768 106.184C98.4005 106.184 94.0217 101.803 94.0217 96.4323C94.0217 91.0617 98.4005 86.6803 103.768 86.6803H103.909C109.277 86.6803 113.514 90.9204 113.656 96.1497C113.656 96.2911 113.656 96.2911 113.656 96.4323C113.656 98.835 112.808 101.096 111.254 102.792C109.277 104.912 106.734 106.184 103.768 106.184Z"
      fill="#E6EDF5"
    />
    <path
      d="M118.176 96.2911H113.515C113.374 91.0617 109.136 86.8217 103.768 86.8217H103.627V82.1577H103.768C111.678 82.1577 118.035 88.3764 118.176 96.2911Z"
      fill="#989FB0"
    />
    <path
      d="M118.176 96.4321C118.176 100.107 116.905 103.357 114.645 105.902L111.114 102.933C112.667 101.238 113.515 98.9761 113.515 96.5735C113.515 96.4321 113.515 96.4322 113.515 96.2908H118.176V96.4321Z"
      fill="#B4BACA"
    />
    <path
      d="M125.804 90.6377C126.662 90.6377 127.357 89.9416 127.357 89.083C127.357 88.2243 126.662 87.5283 125.804 87.5283C124.945 87.5283 124.25 88.2243 124.25 89.083C124.25 89.9416 124.945 90.6377 125.804 90.6377Z"
      fill="#E6EDF5"
    />
    <path
      d="M151.229 96.7137H130.747C130.182 96.7137 129.617 96.2899 129.617 95.5836C129.617 95.0186 130.041 94.4537 130.747 94.4537H151.229C151.794 94.4537 152.359 94.8774 152.359 95.5836C152.218 96.1486 151.794 96.7137 151.229 96.7137Z"
      fill="#E6EDF5"
    />
    <path
      d="M125.804 97.139C126.662 97.139 127.357 96.4429 127.357 95.5843C127.357 94.7257 126.662 94.0296 125.804 94.0296C124.945 94.0296 124.25 94.7257 124.25 95.5843C124.25 96.4429 124.945 97.139 125.804 97.139Z"
      fill="#B4BACA"
    />
    <path
      d="M151.229 103.215H130.747C130.182 103.215 129.617 102.791 129.617 102.085C129.617 101.52 130.041 100.955 130.747 100.955H151.229C151.794 100.955 152.359 101.379 152.359 102.085C152.218 102.65 151.794 103.215 151.229 103.215Z"
      fill="#E6EDF5"
    />
    <path
      d="M125.804 103.64C126.662 103.64 127.357 102.944 127.357 102.085C127.357 101.227 126.662 100.531 125.804 100.531C124.945 100.531 124.25 101.227 124.25 102.085C124.25 102.944 124.945 103.64 125.804 103.64Z"
      fill="#989FB0"
    />
    <path
      d="M89.9255 48.5202H152.359V23.2214L142.471 28.168L137.245 31.8428L127.922 31.7014L119.73 35.9414L112.667 36.9308L110.125 39.7574L102.78 44.4214L95.5757 45.6934L89.9255 48.5202Z"
      fill="#989FB0"
    />
    <path
      d="M89.9255 48.5201H152.359V29.2988L142.471 32.9734L137.245 35.8001L127.922 35.6587L119.73 38.9095L112.667 39.7575L110.125 41.7362L102.78 45.4108L95.5757 46.4002L89.9255 48.5201Z"
      fill="#E6EDF5"
    />
    <path
      d="M89.9255 48.5202H152.359V37.6375L142.471 39.7574L137.245 41.3121H127.922L119.73 43.0081L112.667 43.5735L110.125 44.7042L102.78 46.6829L95.5757 47.2481L89.9255 48.5202Z"
      fill="#CED7E2"
    />
    <defs>
      <filter
        id="filter0_d_178_13623"
        x="0.733246"
        y="9.48963"
        width="175.215"
        height="192.584"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="16.1334" />
        <feGaussianBlur stdDeviation="16.1334" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.18 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_178_13623"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_178_13623"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_178_13623"
        x="67.971"
        y="4.96859"
        width="173.296"
        height="191.733"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="16.1334" />
        <feGaussianBlur stdDeviation="16.1334" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.18 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_178_13623"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_178_13623"
          result="shape"
        />
      </filter>
      <filter
        id="filter2_d_178_13623"
        x="50.596"
        y="0.162704"
        width="141.53"
        height="172.795"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="16.1334" />
        <feGaussianBlur stdDeviation="16.1334" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.18 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_178_13623"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_178_13623"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
export default SvgReportEmpty;
